// @flow
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Logo from "../../components/custom/general/logo/logo";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import Box from "@mui/material/Box";
import Form from "../../components/app/forms/login/form";
import LanguageSelect from "../../components/app/languageSelect/languageSelect";
import ForgotPassword from "../../components/app/dialogs/forgotPassword/forgotPassword";

import useUserAction from "../../hooks/user/useUserAction";
import useUserData from "../../hooks/user/useUserData";

import useLogin from "../../hooks/login/useLogin";
import './login.css'

const Login = () => {
	const { t } = useTranslation(PAGE_LOGIN)
	const { checkAPIConnectivity } = useUserAction()
	const { loading, isLoggedIn } = useUserData()
	const { formik } = useLogin()
	const [openForgotPass, setOpenForgotPass] = useState(false)
	const { userLogin } = useUserAction()
	const history = useHistory();
	
	
	useEffect(() => {
		if (!isLoggedIn) checkAPIConnectivity()
	}, [checkAPIConnectivity, isLoggedIn])
	
	return (<Grid container
	sx={{
		paddingTop: 'env(safe-area-inset-top)',
		paddingBottom: 'env(safe-area-inset-bottom)',
		paddingLeft: 'env(safe-area-inset-left)',
		paddingRight: 'env(safe-area-inset-right)',
		minHeight: '100dvh',
		overflow: 'auto',
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
	}}>
			{/* 1η Στήλη */}
			<Grid
				xs={false}
				sm={3}
				md={4}
				sx={{ display: { xs: 'none', sm: 'flex' } }}
			>
			</Grid>
			{/* 2η Στήλη */}
			<Grid
				// size={{ xs: 12, sm: 6, md: 4 }}
				// sx={{backgroundColor: '#FFFFFF'}}
				xs={12}
				sm={6}
				md={4}
				sx={{
					backgroundColor: '#FFFFFF',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					py: 4,
				}}
			>
				<Box sx={{height: '100%', maxWidth: 400, px: 2  }}>
					<Box
						className={"login"}
					>
						{/*<Box*/}
						{/*	className={'login-box'}*/}
						{/*>*/}
						{/*	<Box p={1}>*/}
						<Box mb={2}>
								<LanguageSelect/>
							</Box>
						<Box mb={2} sx={{ textAlign: 'center' }}>
							<Logo
								style={{
									paddingTop: '1rem',
									width: '120px',     // ορίζεις μέγεθος
									height: 'auto',
									display: 'block',
									marginInline: 'auto' // για έξτρα κεντράρισμα
								}}
							/>
						</Box>
							<Box>
								<Form
									formik={formik}
									loading={loading}
								/>
							</Box>
							<Box>
								{/*<Typography*/}
								{/*	component={Button}*/}
								{/*	onClick={() => setOpe+-*5888888888888888888nForgotPass(true)}*/}
								{/*	variant="body1"*/}
								{/*	color={'secondary'}*/}
								{/*>*/}
								{/*	{t("Forgot password? Click here.")}*/}
								{/*</Typography>*/}
							</Box>
						{/*</Box>*/}
						<ForgotPassword
							open={openForgotPass}
							handleDialog={(newValue) => setOpenForgotPass(newValue)}
						/>
					</Box>
				</Box>
			</Grid>
			{/* 3η Στήλη */}
			<Grid
				// size={{ sm: 3, md: 4 }}
				// display={{ xs: 'none', sm: 'flex' }}
				// sx={{ flexDirection: 'column' }}
				xs={false}
				sm={3}
				md={4}
				sx={{ display: { xs: 'none', sm: 'flex' } }}
			>
			</Grid>
		</Grid>)
}

export default Login